/**
 * @generated SignedSource<<4e5e0d9d3bafadb77e44eb00ef09a292>>
 * @relayHash 18c4852f7ec8f6f30016824f3c4be9cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d694991811b80ccee5c1ce3e650e3bf63a5f29612b9a2458f16fd70e8bdf6d44

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type FolderOverviewFirstPageQuery$variables = {
  after?: string | null;
  contentId: string;
  id: string;
  includeArchiveFolderSupport?: boolean | null;
  includeAutomationDiscovery?: boolean | null;
  includeDevDocsSyncStatus?: boolean | null;
  includeFolderSummary?: boolean | null;
  includeJiraPlannerConnection?: boolean | null;
};
export type FolderOverviewFirstPageQuery$data = {
  readonly folderViewActions?: {
    readonly " $fragmentSpreads": FragmentRefs<"FolderViewActions_query">;
  } | null;
  readonly ptpage: {
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly id: string;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly singleContent: {
    readonly body?: {
      readonly storage: {
        readonly value: string | null;
      } | null;
    } | null;
    readonly contentProperties: {
      readonly latest: {
        readonly coverPicture: string | null;
      } | null;
    } | null;
    readonly devDocsOwnershipProperties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
      } | null> | null;
    } | null;
    readonly devDocsProperties?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly jiraPlannerConnection?: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType?: string | null;
    } | null> | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly status?: string | null;
    readonly subType?: string | null;
    readonly title?: string | null;
    readonly version?: {
      readonly number: number | null;
    } | null;
  } | null;
};
export type FolderOverviewFirstPageQuery = {
  response: FolderOverviewFirstPageQuery$data;
  variables: FolderOverviewFirstPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeArchiveFolderSupport"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutomationDiscovery"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeDevDocsSyncStatus"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeFolderSummary"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeJiraPlannerConnection"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "title"
},
v10 = {
  "kind": "ScalarField",
  "name": "type"
},
v11 = {
  "kind": "ScalarField",
  "name": "subType"
},
v12 = {
  "kind": "ScalarField",
  "name": "status"
},
v13 = {
  "kind": "ScalarField",
  "name": "key"
},
v14 = {
  "kind": "ScalarField",
  "name": "value"
},
v15 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ]
},
v16 = {
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    },
    {
      "kind": "Literal",
      "name": "status",
      "value": [
        "CURRENT",
        "DRAFT"
      ]
    }
  ],
  "concreteType": "PTPage",
  "kind": "LinkedField",
  "name": "ptpage",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    {
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 40
        }
      ],
      "concreteType": "PTPaginatedPageList",
      "kind": "LinkedField",
      "name": "children",
      "plural": false,
      "selections": [
        {
          "concreteType": "PTPage",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v8/*: any*/),
            (v9/*: any*/),
            (v12/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            {
              "concreteType": "Map_LinkType_String",
              "kind": "LinkedField",
              "name": "links",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "webui"
                }
              ]
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "keys",
                  "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                  ]
                }
              ],
              "concreteType": "PaginatedJsonContentPropertyList",
              "kind": "LinkedField",
              "name": "properties",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JsonContentProperty",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v8/*: any*/),
                    (v13/*: any*/),
                    (v14/*: any*/),
                    (v15/*: any*/)
                  ]
                }
              ],
              "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
            }
          ]
        },
        {
          "concreteType": "PTPageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            },
            {
              "kind": "ScalarField",
              "name": "endCursor"
            }
          ]
        }
      ]
    }
  ]
},
v17 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v18 = {
  "condition": "includeArchiveFolderSupport",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v12/*: any*/),
    (v9/*: any*/),
    (v11/*: any*/)
  ]
},
v19 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "condition": "includeArchiveFolderSupport",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    }
  ]
},
v20 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "coverPicture"
        }
      ]
    }
  ]
},
v21 = {
  "condition": "includeFolderSummary",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v15/*: any*/),
    {
      "concreteType": "ContentBodyPerRepresentation",
      "kind": "LinkedField",
      "name": "body",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentBody",
          "kind": "LinkedField",
          "name": "storage",
          "plural": false,
          "selections": [
            (v14/*: any*/)
          ]
        }
      ]
    }
  ]
},
v22 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v8/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ]
  }
],
v23 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v24 = {
  "condition": "includeJiraPlannerConnection",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "jiraPlannerConnection",
      "args": [
        {
          "kind": "Literal",
          "name": "keys",
          "value": [
            "jira-planner-connection"
          ]
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "JsonContentProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v13/*: any*/),
            (v14/*: any*/)
          ]
        }
      ],
      "storageKey": "properties(keys:[\"jira-planner-connection\"])"
    }
  ]
},
v25 = [
  {
    "kind": "Literal",
    "name": "keys",
    "value": [
      "devdocsProperties"
    ]
  }
],
v26 = {
  "alias": "devDocsOwnershipProperties",
  "args": (v25/*: any*/),
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        (v13/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(keys:[\"devdocsProperties\"])"
},
v27 = {
  "condition": "includeDevDocsSyncStatus",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "devDocsProperties",
      "args": (v25/*: any*/),
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v22/*: any*/),
      "storageKey": "properties(keys:[\"devdocsProperties\"])"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FolderOverviewFirstPageQuery",
    "selections": [
      {
        "condition": "includeAutomationDiscovery",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "contentId",
                      "variableName": "contentId"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "FolderViewActions_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "folderViewActions"
          }
        ]
      },
      (v16/*: any*/),
      {
        "args": (v17/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "FolderOverviewFirstPageQuery",
    "selections": [
      (v16/*: any*/),
      {
        "args": (v17/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v8/*: any*/)
        ]
      },
      {
        "condition": "includeAutomationDiscovery",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "user",
            "args": [
              {
                "kind": "Literal",
                "name": "current",
                "value": true
              }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
              {
                "concreteType": "AtlassianUserEmail",
                "kind": "LinkedField",
                "name": "emails",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "isPrimary"
                  }
                ]
              },
              (v8/*: any*/)
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
          },
          {
            "args": (v17/*: any*/),
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v8/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "18c4852f7ec8f6f30016824f3c4be9cb",
    "id": "d694991811b80ccee5c1ce3e650e3bf63a5f29612b9a2458f16fd70e8bdf6d44",
    "metadata": {},
    "name": "FolderOverviewFirstPageQuery",
    "operationKind": "query",
    "text": "query FolderOverviewFirstPageQuery($id:ID!,$after:String,$contentId:ID!,$includeDevDocsSyncStatus:Boolean=false,$includeAutomationDiscovery:Boolean=false,$includeFolderSummary:Boolean=false,$includeArchiveFolderSupport:Boolean=false,$includeJiraPlannerConnection:Boolean=false){...FolderViewActions_query_3SK5LQ@include(if:$includeAutomationDiscovery),ptpage(id:$id,status:[CURRENT,DRAFT]){id,title,type,subType,children(first:40,after:$after){nodes{id,title,status,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage,endCursor}}},singleContent(id:$contentId){status@include(if:$includeArchiveFolderSupport)\n    title@include(if:$includeArchiveFolderSupport)\n    subType@include(if:$includeArchiveFolderSupport),operations{operation,targetType@include(if:$includeArchiveFolderSupport)},contentProperties{latest{coverPicture}},version@include(if:$includeFolderSummary){number}\n    body@include(if:$includeFolderSummary){storage{value}},properties(keys:[\"smartFolderProperties\"]){nodes{id,key,value}},jiraPlannerConnection:properties(keys:[\"jira-planner-connection\"])@include(if:$includeJiraPlannerConnection){nodes{key,value}},devDocsOwnershipProperties:properties(keys:[\"devdocsProperties\"]){nodes{id,key}},devDocsProperties:properties(keys:[\"devdocsProperties\"])@include(if:$includeDevDocsSyncStatus){nodes{id,key,value}},id}}fragment AutomationActionsMenu_query_3SK5LQ on Query{...useKeepUpToDateAction_query_3SK5LQ}fragment FolderViewActions_query_3SK5LQ on Query{...AutomationActionsMenu_query_3SK5LQ}fragment useKeepUpToDateAction_query_3SK5LQ on Query{user:confluence_atlassianUser(current:true){emails{value,isPrimary},id},singleContent(id:$contentId){ancestors{id},id}}"
  }
};
})();

(node as any).hash = "9717d5883492d9cbdc1a8f62d36b484d";

export default node;
